import Api from "./api";

class ChannelApi {
    api = new Api()

    /**
     * @param {string} channel
     * @param {{page: Number, per_page: Number}} pagination
     * @return {Promise<*>}
     */
    publications(channel, pagination) {
        return this.api.get('/zen/channel/publications?dash', {channel, ...pagination})
    }

    /**
     * @param {string} channel
     * @param {{page: Number, per_page: Number}} pagination
     * @return {Promise<*>}
     */
    concurrents(channel, pagination) {
        return this.api.get('/zen/channel/concurrent?dash', {channel, ...pagination})
    }
}

export default new ChannelApi();
